// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestToDivPoint {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {

        app.view.style.left = "100px";
        app.view.style.top = "50px";
        this.onLoad(app, uiStage)
    }
    private _TestImage?: vf.gui.Image;
    private _buttonList: vf.gui.Label[] = [];
    private async onLoad(app: vf.Application, uiStage: vf.gui.Stage) {


        const con = new vf.gui.Container();
        con.x = 60;
        con.y = 10;
        con.scaleX = con.scaleY = 0.9;
        uiStage.addChild(con);

        const img3 = this._TestImage = new vf.gui.Image();
        img3.pivotX = img3.pivotY = 30;
        img3.scaleX = img3.scaleY = 0.5;
        img3.x = 0;
        img3.y = 0;
        img3.src = "assets/bg.png";
        con.addChild(img3);

        //uiStage.extractBase64(img3)



        this.getButton('根据显示对象建立Div节点', () => {
            const point = vf.gui.Utils.toDomRectangle(img3);
            console.log(point);
            const div = document.createElement("img");
            div.src = "assets/bg.png";
            div.style.position = "absolute";
            div.style.width = point.width + "px";
            div.style.height = point.height + "px";
            div.style.left = point.x + "px";
            div.style.top = point.y + "px";
            document.body.appendChild(div);
        }, uiStage, 15, 0);

        this.getButton('根据坐标对象建立Div节点', () => {
            const point = vf.gui.Utils.toDomRectangle(uiStage,{x:100,y:100});
            console.log(point);
            const div = document.createElement("img");
            div.src = "assets/bg.png";
            div.style.position = "absolute";
            // div.style.width = point.width + "px";
            // div.style.height = point.height + "px";
            div.style.left = point.x + "px";
            div.style.top = point.y + "px";
            document.body.appendChild(div);
        }, uiStage, 15, 0);

    }

    private onHover(e: vf.gui.Interaction.InteractionEvent, button: vf.gui.Button, over: boolean) {
        console.log("onHover", over);
        if (over)// eslint-disable-next-line @typescript-eslint/no-explicit-any
            button.text = "移入" + (e as any).type;
        else// eslint-disable-next-line @typescript-eslint/no-explicit-any
            button.text = "移出" + (e as any).type;
    }

    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
    }
    private onRelease() {
        if (this._TestImage) {
            this._TestImage.removeAllListeners();
            this._TestImage.parent && this._TestImage.parent.removeChild(this._TestImage);
            this._TestImage.release();
            this._TestImage = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }
}
